// Zdroj pravdy pre texty landingu — edituje sa ručne. Generátor k tomuto neexistuje.
const cz = {
  "nav": {
    "download": "Stáhnout",
    "features": "Funkce",
    "howItWorks": "Jak to funguje",
    "forEmployees": "Pro zaměstnance",
    "pricing": "Ceník",
    "login": "Přihlášení",
    "tryFree": "Vyzkoušet zdarma",
    "tryFree3": "Vyzkoušet 3 měsíce zdarma",
    "openMenu": "Otevřít menu",
    "closeMenu": "Zavřít menu"
  },
  "employer": {
    "title": "Co získáte jako firma",
    "leadBefore": "Přidáte lidi, vidíte docházku a řešíte žádosti v",
    "leadLink": "aplikaci",
    "leadAfter": "— z počítače, bez instalace.",
    "features": [
      {
        "title": "Kdo je v práci — a kdo ne",
        "description": "Vidíte, kdo pracuje, kdo je na přestávce nebo má volno. Bez obvolávání celého týmu."
      },
      {
        "title": "Firemní chat a hovory",
        "description": "Skupiny podle provozů, hovory i video přímo v aplikaci. Pracovní věci zůstanou ve firmě, ne v soukromém WhatsAppu."
      },
      {
        "title": "Docházka a historie",
        "description": "Příchody, odchody a přestávky. Úpravy záznamů a export pro účetnictví."
      },
      {
        "title": "Pracoviště a QR kódy",
        "description": "QR na vstup nebo recepci. Sken v aplikaci na Androidu i iPhonu."
      },
      {
        "title": "Žádosti od zaměstnanců",
        "description": "Oprava času nebo zapomenutý odchod — schválíte nebo zamítnete jedním kliknutím."
      },
      {
        "title": "AI asistent nad docházkou",
        "description": "Zeptáte se „Kdo je dnes v práci?“ nebo „Kolik hodin měl Petr v červnu?“ — odpověď přijde z vašich dat."
      }
    ]
  },
  "employerPeople": {
    "title": "Co máte v aplikaci",
    "lead": "Přehled o lidech a docházce v prohlížeči na my.effzone.com — ne chat oddělený od toho, kdo je dnes v práci.",
    "block1Title": "Kdo je v práci — a kdo ne",
    "block1Desc": "Vidíte, kdo právě pracuje, kdo je na přestávce nebo má volno. Bez obvolávání celého týmu.",
    "block1Alt": "Effzone — přehled kdo je v práci v aplikaci",
    "block2Title": "Zaměstnanci na pár kliknutí",
    "block2Desc": "Přidáte jméno a telefonní číslo. Člověk dostane SMS kód, přihlásí se a je v systému."
  },
  "employerComms": {
    "title": "Žádosti a zprávy",
    "lead": "Schvalování úprav docházky a oznámení přímo do aplikace zaměstnanců.",
    "block1Title": "Žádosti od zaměstnanců",
    "block1Desc": "Zapomenutý odchod nebo oprava času — pošlou žádost v aplikaci, vy ji schválíte nebo zamítnete.",
    "block2Title": "Zprávy přímo do aplikace",
    "block2Desc": "Oznámení nebo notifikace pro celou firmu nebo jen pro vybrané — bez mailů, které nikdo nečte.",
    "block2Alt": "Effzone — firemní chat a zprávy"
  },
  "employerAttendance": {
    "title": "Docházka a pracoviště",
    "lead": "Historie změn, exporty a QR check-in — bez terminálu nebo speciální čtečky.",
    "block1Title": "Docházka a historie",
    "block1Desc": "Příchody, odchody a přestávky pro každého na každý den. Úpravy záznamů a export, když to potřebujete pro účetnictví.",
    "block2Title": "Pracoviště a QR kódy",
    "block2Desc": "Vytvoříte pracoviště, vytisknete QR a dáte ho na vstup nebo recepci. Zaměstnanec naskenuje v aplikaci na Androidu i iPhonu. Volitelně i omezení podle polohy."
  },
  "faq": {
    "title": "Časté otázky",
    "items": [
      {
        "q": "Co se stane po třech měsících zdarma?",
        "a": "Nic automatického — při registraci od vás nechceme platební kartu. Ozveme se a domluvíme se, jestli budete pokračovat."
      },
      {
        "q": "Sleduje aplikace polohu lidí?",
        "a": "Ne. Poloha se ověří jen ve chvíli označení příchodu na pracovišti (pokud si firma zapne ověřování polohy) — během dne aplikace polohu nesleduje."
      },
      {
        "q": "Co když někdo nemá chytrý telefon?",
        "a": "Docházku si označí přes webový prohlížeč na my.effzone.com, nebo mu záznam doplní admin v aplikaci."
      },
      {
        "q": "Jak dostanu podklady pro mzdy?",
        "a": "Docházku stáhnete do Excelu na pár kliknutí a pošlete účetní jako doteď."
      },
      {
        "q": "Můžeme to kdykoli zrušit?",
        "a": "Ano — bez závazku a bez poplatku. Docházku si před zrušením stáhnete do Excelu."
      }
    ]
  },
  "cta": {
    "title": "Chcete to vyzkoušet ve své firmě?",
    "textBefore": "Založte si účet v",
    "textLink": "aplikaci",
    "textAfter": " nebo nám napište — pomůžeme vám nastavit pracoviště a přidat první zaměstnance.",
    "tryFree": "Vyzkoušet 3 měsíce zdarma",
    "contact": "Napište nám"
  },
  "footer": {
    "downloadApp": "Stáhnout aplikaci",
    "privacy": "Ochrana soukromí",
    "terms": "Podmínky",
    "subprocessors": "Subdodavatelé",
    "admin": "Webová aplikace"
  },
  "storeBadges": {
    "appStore": "Stáhnout v App Store",
    "googlePlay": "Stáhnout na Google Play"
  },
  "hero": {
    "ctaDownload": "Stáhnout aplikaci",
    "headlineLine1": [
      "Docházka"
    ],
    "headlineLine2": [
      "a firemní",
      "komunikace"
    ],
    "headlineAccent": [
      "v",
      "jedné",
      "aplikaci."
    ],
    "lead": "Zaměstnanec si označí příchod přes QR kód při vstupu. Vy vidíte, kdo je v práci a kdo má volno. Novinky, ankety i chat máte v jedné aplikaci — ne po WhatsAppu a mailech, kde se po pár dnech všechno ztratí.",
    "ctaPrimary": "Vyzkoušet 3 měsíce zdarma",
    "pricenote": "První 3 měsíce zdarma · poté 1,90 € za aktivního zaměstnance měsíčně · bez závazku",
    "statsNote": "Čísla z databáze Effzone · září 2026",
    "phoneAlt": "Effzone — přehled kdo je v práci, feed a firemní komunikace",
    "card1Title": "Příchod 07:58",
    "card1Sub": "QR sken · Sklad Bratislava",
    "card2Title": "Nová zpráva",
    "card2Sub": "Ranní směna · 3 reakce",
    "card3Title": "Směna ukončena",
    "card3Sub": "Automaticky v 16:00 · Prodejna Nitra"
  },
  "stats": {
    "shifts": "odpracovaných směn",
    "hours": "odpracovaných hodin",
    "months": "měsíců v provozu"
  },
  "marquee": {
    "qrAttendance": "QR docházka",
    "locationVerify": "Ověření polohy",
    "groupChat": "Skupinový chat",
    "callsVideo": "Hovory a video",
    "aiAssistant": "AI asistent",
    "autoShiftEnd": "Automatické ukončení směn",
    "payrollExport": "Export mezd",
    "changeRequests": "Žádosti o změny",
    "polls": "Ankety",
    "companyNews": "Firemní novinky",
    "multipleWorkplaces": "Více pracovišť",
    "statistics": "Statistiky"
  },
  "howItWorks": {
    "title": "Jak to funguje",
    "steps": [
      {
        "title": "Ověříte si telefonní číslo",
        "descBefore": "Zadáte telefonní číslo, přijde vám SMS kód a v ",
        "linkText": "aplikaci",
        "descAfter": " založíte tým. Trvá to pár minut."
      },
      {
        "title": "Přidáte zaměstnance",
        "description": "Zadáte jméno a telefonní číslo — nebo nahrajete seznam z Excelu. Každému přijde SMS pozvánka a přihlásí se číslem."
      },
      {
        "title": "Vytisknete QR plakát",
        "description": "Hotový A4 plakát s QR kódem a návodem pověsíte tam, kudy lidé přicházejí do práce."
      },
      {
        "title": "Lidé pracují v aplikaci",
        "description": "Označí si příchod, vidí kolegy a firemní novinky. Vy vidíte všechno na dashboardu."
      }
    ]
  },
  "employeeApp": {
    "title": "Co získáte jako zaměstnanec",
    "intro": "Stáhnete aplikaci, přihlásíte se přes SMS a máte docházku, tým i firemní zprávy na jednom místě — v telefonu.",
    "highlights": [
      {
        "title": "Příchod přes QR",
        "description": "Naskenujete kód na pracovišti — bez papírů a čekání."
      },
      {
        "title": "Docházka v telefonu",
        "description": "Historie směn a přestávek kdykoli po ruce."
      },
      {
        "title": "Kdo z kolegů pracuje",
        "description": "Vidíte, kdo je v práci a kdo má volno."
      },
      {
        "title": "Firemní chat a feed",
        "description": "Novinky, ankety a skupinové chaty — oddělené od soukromých zpráv."
      }
    ],
    "badgesLabel": "Stáhněte si mobilní aplikaci",
    "heroAlt": "Effzone — status v práci a firemní feed",
    "galleryLabel": "Ukázky z mobilní aplikace",
    "gallery": [
      {
        "alt": "Effzone — přehled docházky v kalendáři",
        "caption": "Docházka"
      },
      {
        "alt": "Effzone — firemní chat",
        "caption": "Chat a hovory"
      },
      {
        "alt": "Effzone — složky a projekty v chatu",
        "caption": "Složky a projekty"
      }
    ]
  },
  "useCases": {
    "title": "Pro koho to dává smysl",
    "intro": "Tam, kde se dnes docházka a komunikace řeší přes papír, mail nebo soukromé chaty.",
    "items": [
      {
        "title": "Firmy, kde se hodně píše na WhatsApp",
        "description": "Když se pracovní zprávy ztrácejí mezi osobními konverzacemi, jedna firemní aplikace dává větší smysl."
      },
      {
        "title": "Týmy s více pracovišti",
        "description": "QR na každém místě a přehled, kdo kde pracuje — bez papírových výkazů na každém objektu."
      },
      {
        "title": "Častý nástup nových lidí",
        "description": "Admin přidá číslo, člověk se přihlásí a hned vidí tým, pozice a co se ve firmě děje."
      },
      {
        "title": "Malé a střední firmy",
        "description": "Bez velkého HR systému, ale s potřebou vědět, kdo je v práci a domluvit se jako tým."
      }
    ]
  },
  "pricing": {
    "title": "Ceník",
    "badge": "První 3 měsíce zdarma",
    "priceUnit": "/ aktivní zaměstnanec / měsíc",
    "included": [
      "Všechny funkce v jedné ceně — docházka, chat, hovory i AI asistent",
      "Platíte jen za aktivní zaměstnance",
      "Neomezený počet pracovišť a QR kódů",
      "Bez závazku a bez vstupních nákladů",
      "Podklady pro mzdy na pár kliknutí (export do Excelu)"
    ],
    "cta": "Vyzkoušet 3 měsíce zdarma",
    "note": "Ceny jsou uvedené bez DPH. Za zaměstnance bez aktivity v daném měsíci neplatíte nic. Při registraci nezadáváte platební kartu."
  },
  "download": {
    "title": "Effzone na každém vašem zařízení",
    "subtitle": "Jeden účet, stejná data. Docházka i firemní chat na počítači i v mobilu.",
    "downloadFor": "Stáhnout pro",
    "ctaAppStore": "Stáhnout z App Storu",
    "ctaGooglePlay": "Stáhnout z Google Play",
    "mac": "macOS",
    "windows": "Windows",
    "linux": "Linux",
    "ios": "iPhone / iPad",
    "iosDevices": "iPhone a iPad",
    "android": "Android",
    "appStore": "App Store",
    "googlePlay": "Google Play",
    "appleSilicon": "pouze Apple Silicon (M1 a novější)",
    "universal": "Apple Silicon i Intel",
    "intel": "pro Mac s Intelem",
    "otherMacIntel": "Máte starší Mac s Intelem?",
    "otherMacArm": "Máte Mac s Apple Silicon (M1 a novější)?",
    "downloadHere": "Stáhnout",
    "sectionDesktop": "Počítač",
    "sectionMobile": "Mobil",
    "yourSystem": "Váš systém",
    "altDesktop": "Máte jiný počítač?",
    "altMobile": "Effzone je i na počítači —",
    "others": "Ostatní platformy",
    "loading": "Načítám verze…",
    "smartscreen": "Windows může při prvním spuštění ukázat SmartScreen — balíček zatím není podepsaný. Klikněte na „Další informace“ a poté „Přesto spustit“.",
    "feedError": "Verze ke stažení se nepodařilo načíst.",
    "retry": "Zkusit znovu",
    "fact": {
      "notarized": {
        "title": "Podepsáno a ověřeno Applem",
        "text": "macOS balíček prošel notarizací, Gatekeeper ho pustí bez obcházení."
      },
      "selfUpdate": {
        "title": "Aktualizuje se sama",
        "text": "Novou verzi si stáhne na pozadí, nemusíte sem chodit znovu."
      },
      "sameAccount": {
        "title": "Tentýž účet",
        "text": "Přihlásíte se stejně jako v prohlížeči, data jsou stejná."
      }
    }

  }
};

export default cz;
